import './customModalContent.css';

import Modal from '../../Modal/Modal';
import parse from 'html-react-parser';
import Button from 'react-bootstrap/Button';
import { useEffect, useRef } from 'react';

function CustomModalContent({
  title,
  content = '',
  isOpen,
  onClose,
  isHtml = false,
  clickEvent,
  scrollToId = null,
}) {
  const contentRef = useRef();

  useEffect(() => {
    if (isOpen && scrollToId) {
      const timer = setTimeout(() => {
        const el = contentRef.current?.querySelector(`#${scrollToId}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
  
      return () => clearTimeout(timer);
    }
  }, [isOpen, scrollToId]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <header className="content-modal__header">
        <h2 className="content-modal__title">{title}</h2>
        <button className="content-modal__close-btn-icon" onClick={onClose}>
          &times;
        </button>
      </header>
      <div className="content-modal__body"
        key={scrollToId || 'default'}
        ref={contentRef}
        onClick={(event) => clickEvent(event)}
      >
        {isHtml ? parse(content) : content}
      </div>
      <footer className="content-modal__footer">
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </footer>
    </Modal>
  );
}

export default CustomModalContent;
